module.exports = __webpack_public_path__ + "img/rup.ba0d5db4.svg";